// extracted by mini-css-extract-plugin
export default {"qbr-tabs":"QBRs_qbr-tabs__sXSYe","qbr-tab-selected":"QBRs_qbr-tab-selected__FTwM1"};